import styled from "styled-components";
import theme from "styled-theming";

import { ThemeType } from "shared/styles/theme";
import colors from "shared/styles/colors";

export const checkedColor = theme("mode", {
    [ThemeType.light]: colors.grey_1,
    [ThemeType.dark]: colors.grey_4,
});

export const Radio = styled.input`
    -webkit-appearance: none;
    -moz-appearance:    none;
    appearance:         none;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 18px;
    height: 18px;
    margin: 0;
    border: solid 1px ${colors.grey_2};
    border-radius: 100%;

    transition: all .2s;

    &:checked::before {
        content: "";
        background-color: ${checkedColor};
        width: 12px;
        height: 12px;
        border-radius: 100%;
    }
`

Radio.defaultProps = {
    type: "radio"
}